import { Box, Button, Flex, HStack, Icon, Menu, Portal, Text } from '@chakra-ui/react'
import { LuLogOut, LuUser } from 'react-icons/lu'
import { Link, useLocation } from 'react-router-dom'
import {
  getUnionManagerView,
  UNION_MANAGER_ROUTES,
  type UnionManagerView,
} from '@/constants/unionRoutes.constants'

type NavItem = {
  key: UnionManagerView
  label: string
}

type UnionTopNavProps = {
  displayName?: string
  onLogout: () => void
  onSupport: () => void
}

const navItems: NavItem[] = [
  { key: 'orders', label: 'Bestellungen' },
  { key: 'capacityManagement', label: 'Kapazitätssteuerung' },
  { key: 'marketplace', label: 'Marktplatz' },
  { key: 'serviceBilling', label: 'Rechnungsprüfung' },
  { key: 'export', label: 'Datenexport' },
  { key: 'settings', label: 'Bankverwaltung' },
]

export default function UnionTopNav({ displayName, onLogout, onSupport }: UnionTopNavProps) {
  const { pathname } = useLocation()
  const activeView = getUnionManagerView(pathname)

  return (
    <Box
      data-testid="union-top-nav"
      w="full"
      bg="bg"
      borderBottomWidth="1px"
      borderColor="border.muted"
      shadow="xs"
      px={{ base: 4, md: 6 }}
      py={3}
      position="sticky"
      top={0}
      zIndex={20}
    >
      <Flex align="center" justify="space-between" gap={4} wrap="wrap">
        <HStack gap={2} wrap="wrap">
          {navItems.map(item => {
            const active = activeView === item.key

            return (
              <Button
                key={item.key}
                asChild
                variant={active ? 'subtle' : 'ghost'}
                colorPalette="gray"
                borderRadius="xl"
                fontWeight={active ? 'semibold' : 'medium'}
              >
                <Link
                  to={UNION_MANAGER_ROUTES[item.key]}
                  aria-current={active ? 'page' : undefined}
                >
                  {item.label}
                </Link>
              </Button>
            )
          })}

          <Button variant="outline" colorPalette="purple" borderRadius="xl" onClick={onSupport}>
            Support
          </Button>
        </HStack>

        <Menu.Root positioning={{ placement: 'bottom-end' }}>
          <Menu.Trigger asChild>
            <Button variant="ghost" borderRadius="xl">
              <LuUser />
              <Text>{displayName || 'Konto'}</Text>
            </Button>
          </Menu.Trigger>

          <Portal>
            <Menu.Positioner>
              <Menu.Content minW="220px" borderRadius="2xl" p={2}>
                <Menu.Item value="logout" onClick={onLogout}>
                  <HStack>
                    <Icon as={LuLogOut} />
                    <Text>Abmelden</Text>
                  </HStack>
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      </Flex>
    </Box>
  )
}
